import { Stack, Typography } from "@mui/material"
import { CostFigure } from "./cost-figure"

export function SummaryLine({ label, value, currencySymbol }) {
    return (
        <Stack direction="row" spacing={4} justifyContent="flex-end" alignItems="baseline">
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: "right" }}>
                {label}
            </Typography>
            <CostFigure
                value={value}
                currencySymbol={currencySymbol}
                fontWeight={500}
                sx={{ minWidth: 120, textAlign: "right" }}
            />
        </Stack>
    )
}
